export default function Wordmark({ dark = false, size = "md" }) {
  const s = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-xl";
  const main = dark ? "text-[#081226]" : "text-white";
  const box = size === "lg" ? "w-12 h-12" : size === "sm" ? "w-9 h-9" : "w-10 h-10";
  return (
    <div className="flex items-center gap-3 select-none">
      <div className={`${box} rounded-xl flex items-center justify-center shadow-lg shrink-0 p-1.5`}
        style={{ background: "linear-gradient(135deg,#0f2042,#081226)", border: "1px solid rgba(212,175,55,0.35)" }}>
        <img src="/oneiros-medallion-white.png" alt="Oneiros" className="w-full h-full object-contain" />
      </div>
      <div className="leading-none">
        <div className={`font-display font-extrabold tracking-tight ${s} ${main}`}>
          ONEIROS <span className="text-[#E8752A]">VARACHHA</span>
        </div>
        <div className={`text-[10px] tracking-[0.28em] mt-1 ${dark ? "text-slate-500" : "text-slate-400"}`}>
          FITNESS · SPORTS · LEISURE
        </div>
      </div>
    </div>
  );
}
